/* eslint-disable max-statements */
window.aiepkorting = (function() {
  'use strict';

  var wrapper = document.querySelector('.aiepkorting .js-scrollwrap'),
      shadow =  document.querySelector('.aiepkorting .js-scrollshadow'),
      totalSelectedCards = 0;

  function calcDiscount(scrollElements) {
    let total = 0;

    totalSelectedCards = 0;

    for (let element of scrollElements) {
      let cbs = element.querySelectorAll('.custom-checkbox__input:checked');

      if (cbs.length > 0) {
          element.classList.add('is-selected');
          totalSelectedCards = totalSelectedCards + 1;
      } else {
        element.classList.remove('is-selected');
      }
    }
    total = Math.max(0, (totalSelectedCards - 1) * 3);
    document.getElementsByClassName('js-ak-sum')[0].textContent = total;
  }

  function addShadow() {
    let wrapperLeft = wrapper.getBoundingClientRect().left,
        parentLeft = wrapper.parentElement.getBoundingClientRect().left,
        wrapperRight = wrapper.getBoundingClientRect().right,
        parentRight = wrapper.parentElement.getBoundingClientRect().right,
        offsetLeft = Math.round(parentLeft - wrapperLeft),
        offsetRight = Math.round(parentRight - wrapperRight);

    if (offsetLeft > 20) {
      shadow.querySelector('.shadow--left').classList.add('shadow--shown');
    } else {
      shadow.querySelector('.shadow--left').classList.remove('shadow--shown');
    }
    if (offsetRight < -0) {
      shadow.querySelector('.shadow--right').classList.add('shadow--shown');
    } else {
      shadow.querySelector('.shadow--right').classList.remove('shadow--shown');
    }
    wrapper.parentElement.style.setProperty('--offset', offsetLeft + 'px');
  }

  if (wrapper) {
    let cbs = wrapper.getElementsByClassName('custom-checkbox__input'),
    scrollElements = document.getElementsByClassName('js-scrollelement');

    addShadow();

    wrapper.parentElement.addEventListener('scroll', function() {
      addShadow();
    });

    for (let element of scrollElements) {
      element.addEventListener('focus', function(event) {
        let wid = element.offsetWidth,
            tab = element.tabIndex - 1,
            total = wid * tab + (tab * 20);

        setTimeout(function() {
          wrapper.parentElement.scrollTo({
            top: 0,
            left: Number(total),
            behavior: 'smooth'
          });
        }, 100);
      });
    }

    for (let cb of cbs) {
      cb.addEventListener('change', function(event) {
        calcDiscount(scrollElements);
      });
    }
    calcDiscount(scrollElements);
  }
})();
